interface Label {
  id: string;
  name: string;
  color?: string | null;
}

const COLORS = [
  'green',
  'yellow',
  'orange',
  'red',
  'purple',
  'blue',
  'sky',
  'lime',
  'pink',
  'black',
];

const getSortVal = (label: Label) => {
  const v = COLORS.indexOf(label.color || '');

  if (v >= 0) {
    return v;
  } else {
    return Infinity;
  }
};

export const sortLabels = (labels: Label[]) => {
  return [...labels].sort((a, b) => {
    const aSortVal = getSortVal(a);
    const bSortVal = getSortVal(b);

    const cs = aSortVal - bSortVal;

    if (cs !== 0 && !isNaN(cs)) {
      return cs;
    }

    return a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase());
  });
};
